var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "custom-tooltip", style: { backgroundColor: _vm.color } },
    [
      _c("p", [_c("span", [_vm._v(_vm._s(_vm.header) + ":")])]),
      _c("p", [_c("span", [_vm._v(_vm._s(_vm.data[_vm.key]))])]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }